import { NetworkStatus } from '@cbridge-utils/network';

export enum CoverageServerType {
  CTrader = 'cTrader',
  MT5 = 'MT5',
}

// Normalized domain entity — parameters flattened off the API response. Connection params
// are per-type: cTrader carries plant/environment/managerLogin/managerPassword, MT5 carries
// secret/managerId/host/port. Secrets ARE returned on read, so edit forms prefill them.
export interface ICoverageServer {
  serverId: number;
  name: string;
  type: CoverageServerType;
  // cTrader
  plant?: string;
  environment?: string;
  managerLogin?: string;
  managerPassword?: string;
  // MT5
  secret?: string;
  managerId?: string;
  host?: string;
  port?: number;
}

// RHF form shape.
export interface ICoverageServerForm {
  serverId?: number;
  name: string;
  type: CoverageServerType;
  plant?: string;
  environment?: string;
  managerLogin?: string;
  managerPassword?: string;
  secret?: string;
  managerId?: string;
  host?: string;
  port?: number;
}

export interface ICoverageServerStore {
  data: Record<ICoverageServer['serverId'], ICoverageServer>;
  listNetworkStatus: NetworkStatus;
}

export interface ICoverageServerStoreSegment {
  coverageServer: ICoverageServerStore;
}
